<template>
  <div class="TodayStatistics">
    <div class="search">
      <div class="search_box">
        <div  class="search_options_box">
          <span style="width: 100px;">{{search[0].title}}</span>
          <el-select class="select" v-model="selectProjectValue" placeholder="请选择项目" @change="getSelectTeam(selectProjectValue )">
            <el-option v-for="item in search[0].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </div>
        <div  class="search_options_box">
          <span style="width: 100px;">{{search[1].title}}</span>
          <el-select class="select" v-model="selectTeamValue" placeholder="请选择群组" @change="getSelectWork(selectTeamValue )">
            <el-option v-for="item in search[1].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </div>
        <div  class="search_options_box">
          <span style="width: 100px;">{{search[2].title}}</span>
          <el-select class="select" v-model="selectWorkValue" placeholder="请选择小组" >
            <el-option v-for="item in search[2].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </div>
        <div class="search_btn_box">
          <button :class='["search_btn","green","icon_btn","clearborder"]' @click="">
            <span class="el-icon-search"></span>搜索
          </button>
        </div>
      </div>
      <div class="search_information">
        <div v-for="(item,index) in statistics" class="search_information_content">
          <div>
            <span class="icon-8" v-bind:style="[{color:item.color}]"></span>
          </div>
          <div>
            <p>{{item.name}}</p>
            <span v-bind:style="[{color:item.color}]">{{statistics_number[index].number}}</span>
          </div>
        </div>
      </div>
    </div>
    <div :class='["information_box","gridding","light_border"]'
         :style="[{width:'63.6%'},{'min-height':'270px'},{height:'32.5%'}]">
      <div class="border_top_left"></div>
      <div class="border_top_right"></div>
      <div class="border_bottom_left"></div>
      <div class="border_bottom_right"></div>
      <div class="h_light_right" :style="{top:'95px'}"></div>
      <div class="information_title">
        <p>今日汇总</p>
        <div></div>
      </div>
      <div class="information_content">
        <div class="electric">
          <div>
            <div>电量</div>
            <p>
              <span v-for="(item,index) in eelectric">{{item.number}}</span>
              <a>度</a>
            </p>
          </div>
        </div>
        <div class="electric_box">
          <ul class="clectric_content">
            <li :style="[{width: '45%'}]">
              <div>
                <img src="/static/img/icon/pile1.png"/>
              </div>
              <div>
                <div>
                  <span :style="[{color:'#00fafe'}]">0</span>时
                  <span :style="[{color:'#00fafe'}]">00</span>分
                  <span :style="[{color:'#00fafe'}]">00</span>秒
                </div>
                <p>充电时长</p>
              </div>
            </li>
            <li>
              <div>
                <img src="/static/img/icon/pile2.png"/>
              </div>
              <div>
                <div>
                  <span :style="[{color:'#00fafe'}]">0</span>条
                </div>
                <p>充电记录</p>
              </div>
            </li>
            <li>
              <div>
                <img src="/static/img/icon/pile3.png"/>
              </div>
              <div>
                <div>
                  <span :style="[{color:'#e84366'}]">0</span>辆
                </div>
                <p>当天车数量</p>
              </div>
            </li>
            <li :style="[{width: '45%'}]">
              <div>
                <img src="/static/img/icon/pile1.png"/>
              </div>
              <div>
                <div>
                  <span :style="[{color:'#00fafe'}]">00</span>分
                  <span :style="[{color:'#00fafe'}]">00</span>秒
                </div>
                <p>单次最长充电时长</p>
              </div>
            </li>
            <li>
              <div>
                <img src="/static/img/icon/pile4.png"/>
              </div>
              <div>
                <div>
                  <span :style="[{color:'#ffa200'}]">0</span>度
                </div>
                <p :style="[{width:'64px'}]">单次最大充电电量</p>
              </div>
            </li>
            <li>
              <div>
                <img src="/static/img/icon/pile5.png"/>
              </div>
              <div>
                <div>
                  <span :style="[{color:'#00fafe'}]">0</span>条
                </div>
                <p>补发记录</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div :class='["information_box","gridding","light_border"]'
         :style="[{width:'calc(36.4% - 14px)'},{'min-height':'270px'},{height:'32.5%'},{'margin-left':'10px'}]">
      <div class="border_top_left"></div>
      <div class="border_top_right"></div>
      <div class="border_bottom_left"></div>
      <div class="border_bottom_right"></div>
      <div class="h_light_right" :style="{top:'95px'}"></div>
      <div class="information_title_sm">
        <p>基本信息</p>
        <div></div>
      </div>
      <div class="information_content">
        <ul class="basic">
          <li v-for="(item,index) in basic">
            <div v-bind:style="[{background:'url('+item.icon+') no-repeat center center'}]"></div>
            <div>
              <p>{{item.name}}</p>
              <p>{{model[index].name}}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div :class='["information_box","light_border"]'
         :style="[{width:'76%'},{height:'46%'},{'min-height':'395px'},{'margin':'30px 0px 10px'}]">
      <div class="border_top_left"></div>
      <div class="border_top_right"></div>
      <div class="border_bottom_left"></div>
      <div class="border_bottom_right"></div>
      <div class="h_light_right" :style="{top:'95px'}"></div>
      <div class="information_title">
        <p>充电记录</p>
        <div></div>
      </div>
      <div class="information_content">
        <div class="record">
          <div class="table_search">
            时间<input id="start" type="text"/>
            至<input id="end" type="text"/>
            <button class="green">搜索</button>
          </div>
          <div class="table_content">
            <table>
              <thead>
              <tr>
                <th>充电编码</th>
                <th>开始时间</th>
                <th>结束时间</th>
                <th>充电电量/度</th>
                <th>消费金额/元</th>
                <!--                <th>车辆总电量/度</th>-->
                <!--                <th>充电结束时车辆SOC</th>-->
                <th>停止方法</th>
              </tr>
              </thead>
              <tbody>
              <tr v-if="!tabledata">
                <td colspan="6">暂无充电记录</td>
              </tr>
              <tr v-else v-for="(item,index) in tabledata">
                <td>{{item.name}}</td>
                <td>{{item.startTime}}</td>
                <td>{{item.endTime}}</td>
                <td>{{item.voltameter}}</td>
                <td>{{item.cash}}</td>
                <!--                <td>{{item.allelectric}}</td>-->
                <!--                <td>{{item.soc}}</td>-->
                <td>
                  <span
                    :class="item.type==0?'table_warning':'table_normal'"
                    v-bind:style="[{display:'inline-block'},{width:'60px'},{height:'22px'}]">
                    {{item.type==0?'手动':'自动'}}
                  </span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div v-if="!tabledata" class="table_paging"></div>
          <div v-else class="table_paging">
            <p>
              当前记录<span>{{1+page_start*page_size}}</span>到<span>{{5+page_start*page_size}}</span>条，共<span>{{total}}</span>条记录
              <button
                @click="firstpgae()"
                v-bind:style="[{background:'url(/static/img/icon/table_start.png) no-repeat center center'}]"></button>
              <button
                @click="prevpgae()"
                v-bind:style="[{background:'url(/static/img/icon/table_prep.png) no-repeat center center'}]"></button>
              第<span>{{page_start+1}}</span>/<span>5</span>页
              <button
                @click="nextpgae()"
                v-bind:style="[{background:'url(/static/img/icon/table_next.png) no-repeat center center'}]"></button>
              <button
                @click="lastpgae()"
                v-bind:style="[{background:'url(/static/img/icon/table_end.png) no-repeat center center'}]"></button>
            </p>
          </div>
        </div>
      </div>
    </div>


    <div :class='["information_box","gridding","light_border"]'
         :style="[{width:'calc(24% - 14px)'},{height:'46%'},{'margin':'30px 0 10px 10px'},{'min-height':'395px'}]">
      <div class="border_top_left"></div>
      <div class="border_top_right"></div>
      <div class="border_bottom_left"></div>
      <div class="border_bottom_right"></div>
      <div class="h_light_right" :style="{top:'0'}"></div>
      <div class="information_content">
        <div class="charts">
          <h1 class="charts-title">设备实时工况</h1>
          <!--<p><span></span>电流<span></span>电压</p>-->
          <div id="Real-timeStatus"></div>
          <h1 class="charts-title">各状态时长统计图</h1>
          <div id="StatusStatistics"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  //引入echarts
  let echarts = require('echarts/lib/echarts')
  // 引入柱状图组件
  require('echarts/lib/chart/bar')
  require('echarts/lib/chart/line')
  require('echarts/lib/chart/pie')
  // 引入提示框和title组件
  require('echarts/lib/component/tooltip')
  require('echarts/lib/component/title');
  require('echarts/lib/component/legend');


  export default {
    name: "TodayStatistics",
    data() {
      return {
        search: [
          {
            title: '选择项目',
            options: [],
          }, {
            title: '选择群组',
            options: [],
          }, {
            title: '选择小组',
            options: [],
          },
        ],
        statistics: [
          {name: "总数", color: "#00fffc"},
          {name: "空闲", color: "#33f08f"},
          {name: "占用", color: "#ffbd4a"},
          {name: "故障", color: "#f32061"},
        ],
        statistics_number: [
          {number: "0"},
          {number: "0"},
          {number: "0"},
          {number: "0"},
        ],
        eelectric: "0000",
        basic: [
          {name: "主机型号", icon: "/static/img/icon/pile6.png"},
          {name: "主机电压范围", icon: "/static/img/icon/pile7.png"},
          {name: "主机编号", icon: "/static/img/icon/pile8.png"},
          {name: "主机电流范围", icon: "/static/img/icon/pile9.png"},
          {name: "主机功率", icon: "/static/img/icon/pile10.png"},
          {name: "环境温度", icon: "/static/img/icon/pile11.png"},
          {name: "功率单元", icon: "/static/img/icon/pile10.png"},
        ],
        model: [
          {name: "KY-2019xxxx"},
          {name: "KY-2019xxxx"},
          {name: "KY-2019xxxx"},
          {name: "200-500VDC"},
          {name: "KY-2019xxxx"},
          {name: "35℃"},
          {name: "KY-2019xxxx"},
        ],

        tabledata: [
          {
            name: "8888",
            startTime: "2019-08-08 19:49",
            endTime: "2019-08-08 19:49",
            voltameter: "888",
            cash: "888",
            allelectric: "888",
            soc: "888",
            type: "0"
          },
          // {
          //   name: "8888",
          //   startTime: "2019-08-08 19:49",
          //   endTime: "2019-08-08 19:49",
          //   voltameter: "888",
          //   cash: "888",
          //   allelectric: "888",
          //   soc: "888",
          //   type: "1"
          // },
          // {
          //   name: "8888",
          //   startTime: "2019-08-08 19:49",
          //   endTime: "2019-08-08 19:49",
          //   voltameter: "888",
          //   cash: "888",
          //   allelectric: "888",
          //   soc: "888",
          //   type: "1"
          // },
          // {
          //   name: "8888",
          //   startTime: "2019-08-08 19:49",
          //   endTime: "2019-08-08 19:49",
          //   voltameter: "888",
          //   cash: "888",
          //   allelectric: "888",
          //   soc: "888",
          //   type: "1"
          // },
          // {
          //   name: "8888",
          //   startTime: "2019-08-08 19:49",
          //   endTime: "2019-08-08 19:49",
          //   voltameter: "888",
          //   cash: "888",
          //   allelectric: "888",
          //   soc: "888",
          //   type: "1"
          // },
          // {
          //   name: "8888",
          //   startTime: "2019-08-08 19:49",
          //   endTime: "2019-08-08 19:49",
          //   voltameter: "888",
          //   cash: "888",
          //   allelectric: "888",
          //   soc: "888",
          //   type: "1"
          // },
        ],
        chart_circle: [
          {
            "name": "空闲占枪",
            "value": 10
          }, {
            "name": "维护",
            "value": 10
          }, {
            "name": "空闲",
            "value": 10
          }, {
            "name": "充电",
            "value": 10
          }, {
            "name": "故障",
            "value": 10
          }
        ],
        //初始化分页
        page_size: 5,
        page_start: 0,
        total: '',
      }
    },
    mounted() {
      this.getProjectList();
      this.init();
      this.electric();
      this.firstpgae();
    },
    methods: {
      InitLeftMenu: function () {
        this.$emit('getMessage', '7', '0');
      },

      //获取小组列表
      getSelectWork:function(id){
        fetch("/api/v1/controller/list", {
          method: 'post',
          body: JSON.stringify({
            "groups_id":id,
            "page_size":10,
            "page_start":0,
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          //.then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "小组数据获取成功";
              this.search[2].options=[];
              this.workList = data.data;
              let options = this.search[2].options;
              for (let i=0;i<this.workList.length;i++){
                let projectObj = {};
                projectObj.label = this.workList[i].name;
                projectObj.value = this.workList[i].id;
                options.push(projectObj);
              };
            } else {
              this.message = "数据更新异常，请重试";
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },



      //获取群组列表
      getSelectTeam:function(id){
        fetch("/api/v1/groups/list", {
          method: 'post',
          body: JSON.stringify({
            "project_id":id,
            "page_size":10,
            "page_start":0,
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          //.then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "群组数据获取成功";
              this.search[1].options=[];
              this.search[2].options=[];
              this.teamList = data.data;
              let options = this.search[1].options;
              for (let i=0;i<this.teamList.length;i++){
                let projectObj = {};
                projectObj.label = this.teamList[i].name;
                projectObj.value = this.teamList[i].id;
                options.push(projectObj);
              };
            } else {
              this.message = "数据更新异常，请重试";
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },


      //获取项目列表
      getProjectList:function(){
        fetch("/api/v1/project/list", {
          method: 'post',
          body: JSON.stringify({

          })
        })
          .then(result => {
            return result.json();//解析流
          })
          //.then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "项目数据获取成功";
              this.projectList = data.data;
              let options = this.search[0].options;
              for (let i=0;i<this.projectList.length;i++){
                let projectObj = {};
                projectObj.label = this.projectList[i].name;
                projectObj.value = this.projectList[i].id;
                options.push(projectObj);
              };
            } else {
              this.message = "数据更新异常，请重试";
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },


      electric: function () {
        var aa = this.eelectric;
        var bb = new Array();
        for (var i = 0; i < aa.length; i++) {
          bb.push({number: aa[i]});
        }
        this.eelectric = bb;
      },
      init: function () {
        // 基于准备好的dom，初始化echarts实例
        let myChart1 = echarts.init(document.getElementById('Real-timeStatus'));
        // 绘制图表
        myChart1.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              lineStyle: {
                color: '#57617B'
              }
            }
          },
          legend: {
            icon: 'rect',
            itemWidth: 18,
            itemHeight: 10,
            itemGap: 13,
            data: ['电流', '电压',],
            right: '0%',
            top: '0%',
            textStyle: {
              fontSize: 14,
              color: '#fff'
            }
          },
          grid: {
            left: '0%',
            right: '5%',
            bottom: '0%',
            top: "15%",
            containLabel: true
          },
          xAxis: [{
            boundaryGap: false,
            type: 'category',
            axisTick: {
              show: false
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#ffffff'
              }
            },
            axisLabel: {
              textStyle: {
                fontSize: 12
              }
            },
            data: ['13:00', '14:00', '15:00', '16:00', '17:00', '18:00',]
          }],
          yAxis: [{
            type: 'value',
            axisTick: {
              show: false
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#DDD'
              }
            },
            axisLabel: {
              textStyle: {
                fontSize: 12
              }
            },
            splitLine: {
              show: false
            }
          }],
          series: [{
            name: '电流',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 3
              }
            },
            itemStyle: {
              normal: {
                color: '#ea436d',
              },
            },
            data: [32, 34, 39, 35, 38, 36, 34]
          }, {
            name: '电压',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 3
              }
            },
            itemStyle: {
              normal: {
                color: '#0de9f7',
              },
            },
            data: [25, 22, 26, 28, 27, 26, 23]
          }]
        });

        var data = this.chart_circle
        let myChart2 = echarts.init(document.getElementById('StatusStatistics'));
        // 绘制图表
        myChart2.setOption({
          color: ['#d90051', '#00bd8d', '#9702fe', '#ffb508', '#01b4d2'],
          grid: {
            bottom: 150,
            left: 100,
            right: '10%'
          },
          legend: {
            orient: 'vertical',
            top: "middle",
            itemWidth: 10,
            itemHeight: 10,
            right: "8%",
            textStyle: {
              color: '#ffffff',
              fontSize: 14,

            },
            icon: 'circle',
            data: data,
          },
          series: [
            // 主要展示层的
            {
              radius: ['45%', '70%'],
              center: ['30%', '50%'],
              type: 'pie',
              label: {
                normal: {
                  show: true,
                  formatter: "{c}%",
                  textStyle: {
                    fontSize: 12,
                    color: '#fff',

                  },
                  position: 'outside'
                },
                emphasis: {
                  show: true
                }
              },
              labelLine: {
                normal: {
                  show: true,
                  length: 10,
                  length2: 15,
                  lineStyle: {
                    color: '#ffffff'
                  }
                },
                emphasis: {
                  show: true
                }
              },
              name: "民警训练总量",
              data: data,

            },
          ]
        });
        window.onresize = function () {
          myChart1.resize();
          myChart2.resize();
        };
        var start = {}, end = {};
        jeDate('#start', {
          theme: {bgcolor: "#2677c6", color: "#ffffff", pnColor: "#01b4d2"},
          format: 'YYYY-MM-DD',
          minDate: '1899-01-01', //设定最小日期为当前日期
          maxDate: '2299-01-01', //设定最大日期为当前日期
          donefun: function (obj) {
            end.minDate = obj.val; //开始日选好后，重置结束日的最小日期
            jeDate("#end", LinkageEndDate(false));
          }
        });
        jeDate('#end', LinkageEndDate);

        function LinkageEndDate(istg) {
          return {
            theme: {bgcolor: "#2677c6", color: "#ffffff", pnColor: "#01b4d2"},
            trigger: istg || "click",
            format: 'YYYY-MM-DD',
            minDate: function (that) {
              //that 指向实例对象
              var nowMinDate = jeDate.valText('#start') === "" && jeDate.valText(that.valCell) === "";
              return nowMinDate ? jeDate.nowDate({DD: 0}) : end.minDate;
            }, //设定最小日期为当前日期
            maxDate: '2299-01-01', //设定最大日期为当前日期
            donefun: function (obj) {
              start.maxDate = obj.val; //将结束日的初始值设定为开始日的最大日期
            }
          };
        }


      },


      firstpgae: function () {
        this.$axios.post('/api/v1/pile/list',{
            params:{
              page_start:0,
              page_size:10,
            },
        })
          .then((res) => {
            if (res.data.code === "200") {
              console.log(res);
              this.total = res.data.total;
              this.tabledata = res.data.data;
              console.log(this.tabledata)
            }
          })
          .catch((err) => {
            throw  err
          })
      },
      prevpgae: function () {
        if (this.page_start === 0) {

        }
      }

    },
    created() {
      this.InitLeftMenu()
    }
  }
</script>

<style scoped>
  .TodayStatistics {
    width: 100%;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .search {
    width: 100%;
    height: 100px;
    padding: 10px 0;
  }

  .search_box {
    width: 70%;
    height: 100%;
    margin-right: 10px;
    background: #16518d;
    border-radius: 6px;
    float: left;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .search_options_box {
    width: calc(25% - 20px);
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;

    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .search_options_box > span {
    width: 64px;
    margin-right: 8px;
    text-align: right;
    color: #FFFFFF;
  }

  .search_options_box > select {
    width: calc(100% - 72px);
    height: 36px;
    border-radius: 6px;

    background: transparent;
    border: 1px solid #a2b9d1;
    color: #a2b9d1;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  .search_options_box option {
    color: #000000;
  }

  .search_options_box > img {
    position: absolute;
    top: 48px;
    right: 20px;
    cursor: pointer;
  }

  .search_btn_box {
    width: 80px;
    padding: 10px;
  }

  .clearborder {
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .search_btn {
    width: 100%;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
  }

  .icon_btn span {
    margin-right: 8px;
  }

  .green {
    background: #21b868;
    color: #FFFFFF;
  }

  .green:active {
    background: #15a95a;
  }

  .search_information {
    width: calc(30% - 10px);
    float: left;
    height: 100%;
    background: #16518d;
    border-radius: 6px;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .search_information_content {
    padding: 10px;
    width: 25%;
    height: 100%;
    float: left;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }

  .search_information_content > div:nth-child(1) {
    min-width: 36px;
    min-height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    margin-right: 10px;
  }

  .search_information_content > div:nth-child(1) > span {
    font-size: 20px;
  }

  .search_information_content > div:nth-child(2) {
    width: auto;
    height: 50px;
  }

  .search_information_content > div:nth-child(2) > p {
    line-height: 20px;
    height: 20px;
    font-size: 14px;
    text-align: left;
    color: #FFFFFF;
    margin-bottom: 0;
  }

  .search_information_content > div:nth-child(2) > span {
    font-family: '$number';
    font-size: 30px;
    height: 30px;
    line-height: 30px;
    text-align: left;
  }

  .electric {
    width: 310px;
    height: 100%;
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .electric > div {
    min-width: 228px;
    height: 100px;
    border: 1px solid #00ff00;
    padding-left: 54px;
    box-sizing: border-box;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .electric > div > div {
    position: absolute;
    left: 0;
    top: 0;
    width: 54px;
    height: 98px;
    background: #32be32;
    font-size: 24px;
    color: #FFFFFF;
    padding: 12px 15px;
    box-sizing: border-box;
  }

  .electric > div > p {
    margin: 0;
    height: 42px;
    display: flex;
    align-items: flex-end;
  }

  .electric > div > p > span {
    width: 24px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 1px;
    background: #32be32;
    font-size: 36px;
    color: #FFFFFF;
    font-family: "Humnst777";
  }

  .electric > div > p > a {
    color: #FFFFFF;
    margin-left: 2px;
    font-size: 14px;
  }

  .electric_box {
    width: calc(100% - 310px);
    height: 100%;
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .electric_box > ul {
    width: auto;
  }

  .electric_box > ul > li {
    width: 27.5%;
    float: left;
    margin: 10px 0;
  }

  .electric_box > ul > li > div:nth-child(1) {
    width: 58px;
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
    float: left;
  }

  .electric_box > ul > li > div:nth-child(2) {
    width: calc(100% - 58px);
    float: left;
  }

  .electric_box > ul > li > div:nth-child(2) > div {
    height: 34px;
    text-align: left;
    font-size: 16px;
    line-height: 34px;
    color: #c9def6;
    margin-bottom: 4px;
  }

  .electric_box > ul > li > div:nth-child(2) > div > span {
    font-family: "$number";
    font-size: 34px;
    margin-right: 2px;
  }

  .electric_box > ul > li > div:nth-child(2) > p {
    margin: 0;
    height: 20px;
    line-height: 20px;
    font-size: 16px;
    box-sizing: border-box;
    color: #c9def6;
  }

  .basic {
    width: 80%;
    margin: 0 10%;
    padding-top: 3%;
    height: 100%;
    box-sizing: border-box;
  }

  .basic > li {
    width: 50%;
    height: 25%;
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }

  .basic > li > div:nth-child(1) {
    width: 38px;
    height: 38px;
    margin-right: 14px;
  }

  .basic > li > div:nth-child(2) {
    width: 140px;
    height: 44px;
  }

  .basic > li > div:nth-child(2) > p {
    height: 22px;
    line-height: 22px;
    margin-bottom: 0;
  }

  .basic > li > div:nth-child(2) > p:nth-child(1) {
    color: #00fafe;
  }

  .basic > li > div:nth-child(2) > p:nth-child(2) {
    color: #FFFFFF;
  }

  .record {
    width: 100%;
    height: 100%;
    padding: 20px 10px;
    box-sizing: border-box;
  }

  .table_search {
    width: 100%;
    height: 26px;
    color: #c1c2c6;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 50px;
    box-sizing: border-box;
  }

  .table_search > input {
    margin: 0 10px;
    width: 116px;
    background: transparent;
    color: #c1c2c6;
    text-align: right;
    font-size: 14px;
    border: 1px solid #556e88;
    padding-right: 5px;
    box-sizing: border-box;
    border-radius: 3px;
    outline: none;
    cursor: pointer;
  }

  .table_search > button {
    height: 24px;
    border-radius: 3px;
    width: 60px;
    border: none;
    outline: none;
  }

  .table_content {
    width: 100%;
  }

  .table_content > table {
    width: 100%;
    height: 100%;
  }

  .table_content > table tr {
    border-bottom: 1px solid #225892;
    height: 42px
  }

  .table_content > table tr td, .table_content > table tr th {
    text-align: center;
    color: #FFFFFF;
  }

  .table_paging {
    height: 50px;
    width: 100%;
    display: flex;
    align-items: center;
  }

  .table_paging > p {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: right;
    margin-bottom: 0;
    color: #c1c2c6;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
  }

  .table_paging > p > button {
    margin: 0 8px;
    width: 10px;
    height: 16px;
    border: none;
    outline: none;
  }

  .charts {
    width: 100%;
    height: 100%;
    padding: 10px;
    box-sizing: border-box;
  }

  .charts-title {
    font-size: 16px;
    color: #FFFFFF;
    height: 20px;
    margin-top: 10px;
    line-height: 20px;
    margin-bottom: 5px;
  }

  #Real-timeStatus, #StatusStatistics {
    height: calc(50% - 35px);
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/03Monitoring/8_chargingpile/TodayStatistics.vue